import React, {useState, useEffect} from 'react'
import { Grid, makeStyles } from '@material-ui/core';
import ModalBase from '../../../../../components/Modals/ModalBase';
import DisplayText from '../../../../../components/Texts/DisplayText';
import LineInputText from '../../../../../components/Inputs/LineInputText/LineInputText';
import LineInputSelect from '../../../../../components/Inputs/LineInputSelect/LineInputSelect';
import { generalCatalogs } from '../../../../../variables/catalogs';
import { onValidateForm } from '../../../../../shared/utility';
import {request_edit_vehicle} from '../../requests'
import SubmitModalButton from '../../../../../components/Buttons/SubmitModalButton';

const useStyles = makeStyles(theme => ({
    root:{
        position:'relative'
    },
    buttonContainer:{
        marginTop:32
    }
}))

const EditCarModal = props => {

    const classes = useStyles()
    const {initData, open, onClose, onUpdateCars, patientID} = props
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [valid, setValid] = useState(false)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if(!initData) return
        let temp = {...form}
        Object.keys(form).forEach( item =>{
            let newValue = initData[item] 
            if(newValue !== null && newValue !== undefined){
                temp[item].value = newValue
                temp[item].isValid = true
                temp[item].isVisited = true
            }
        })
        setValid(onValidateForm(temp))
        setForm(temp)
    }, [open, initData])



    const onInputChange = (data) => {
        const id = data.config.id;
        let temp = {...form};
        temp[id] = {...data};
        setValid(onValidateForm(temp))
        setForm(temp)
    }

    const onSubmit = async() => {
        if(!valid){
            setError('Llena los campos faltantes')
            return
        }
        
        let data2send = {patient_id: patientID}
        const {id_car} = initData

        Object.keys(form).forEach(item => {
            if((initData[item] !== form[item].value) && form[item].isValid){
                data2send = {...data2send, [item]: form[item].value}
            }
        })
        setLoading(true)
        try {
            const cars = await request_edit_vehicle(patientID, id_car, data2send)
            setLoading(false)
            onUpdateCars(cars)
            onClose()
        } catch (error) {
            console.log(error)
            setError('Hubo un error')
            setLoading(false)
        }

    }

    return(
        <ModalBase open={open} onClose={onClose}>
            <div className={classes.root}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <DisplayText variant='h6'>Editar vehículo</DisplayText>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <LineInputText
                                data={form.name}
                                onChange={onInputChange}/>
                            </Grid>
                            <Grid item xs={12}>
                                <LineInputSelect
                                data={form.car_type_id}
                                onChange={onInputChange}/>
                            </Grid>
                            <Grid item xs={12}>
                                <LineInputSelect
                                data={form.car_range_id}
                                onChange={onInputChange}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <SubmitModalButton error={error} loading={loading} onSubmit={onSubmit}/>
                    </Grid>
                </Grid>
            </div>
        </ModalBase>
    )
}

export default EditCarModal

const formData = {
    name:{
        value: null,
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config:{
          id:'name',
          type:'text',
          fullWidth: true,
          label:'Nombre',
          placeholder:'Ingrese un nombre para identificar el vehículo...'
        },
        rules:{type:'distance'}
    },
    car_type_id:{
        value: null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        options:[...generalCatalogs.car_types ],
        config:{
          id:'car_type_id',
          type:'select',
          fullWidth: true,
          label:'Tipo',
          placeholder:'Seleccione una opción...'
        },
        rules:{
          type:'select',
        }
    },
    car_range_id:{
        value: null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        options:[...generalCatalogs.car_ranges ],
        config:{
          id:'car_range_id',
          type:'select',
          fullWidth: true,
          label:'Rango',
          placeholder:'Seleccione una opción...'
        },
        rules:{
          type:'select',
        }
    },
}